import type {HelpFile} from '../../types/help'
import {ScopePreviewPanelTestIds} from '../../../testids/ScopePreviewPanelTestIds'

export const scopePreviewPanelHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [ScopePreviewPanelTestIds.colPreviewIdentity]:
            'The identity whose access assignment falls within the scope.',
        [ScopePreviewPanelTestIds.colPreviewProfile]:
            'The access profile (code and name) granted to the identity.',
        [ScopePreviewPanelTestIds.colPreviewResource]:
            'The protected resource the access profile grants.',
        [ScopePreviewPanelTestIds.colPreviewRiskLevel]:
            'The risk level of the matched assignment.',
        [ScopePreviewPanelTestIds.scopePreviewPanel]: null,
        [ScopePreviewPanelTestIds.previewNoQuery]: null,
        [ScopePreviewPanelTestIds.previewLoading]: null,
        [ScopePreviewPanelTestIds.previewInScope]: null,
        [ScopePreviewPanelTestIds.previewZeroMatchWarning]: null,
        [ScopePreviewPanelTestIds.previewErrorBanner]: null,
        [ScopePreviewPanelTestIds.previewSampleCaption]: null,
        [ScopePreviewPanelTestIds.previewTooLarge]: null,
        [ScopePreviewPanelTestIds.previewFrequencyDisclaimer]: null,
        [ScopePreviewPanelTestIds.tablePreviewResults]: null,
        [ScopePreviewPanelTestIds.btnPreviewRetry]: null,
    },
}
